import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import Button from '@plasma/ui.general.button';

import { AllPersonnelTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<AllPersonnelTheme>;
const css = baseCss as ThemedCssFunction<AllPersonnelTheme>;

export const AllPersonnel = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f8fafc;
  overflow: hidden;
  box-sizing: border-box;
`;

export const HeaderToolbar = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 18px 0 12px 20px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.04);
`;

export const TableContainer = styled.div`
  flex: 1;
  overflow: auto;
  padding: 8px;
  margin-top: 8px;
  box-sizing: border-box;

  .editable-table {
    height: 100%;
    max-height: 100%;
    width: 100%;
    overflow: auto;
  }

  table {
    th,
    td {
      /* white-space: nowrap; */
    }
  }
`;

export const ModalTopBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 8px;
`;

export const StatusToggleBox = styled.div<{ $isActive?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 6px;
  background-color: ${(props) => (props.$isActive ? '#f2ffcc' : '#e6e6e6')};
  border: 2px solid #75a3a3;
  box-shadow: ${(props) => (props.$isActive ? '0px 0px 5px 2px #f2ffcc' : 'none')};
  font-weight: bold;
  font-size: 14px;
`;

export const ModalContainer = styled.div`
  ${({ theme }) => css`
    background: ${theme.mode?.allPersonnel?.modalContainerBGColor || '#ffffff'};
  `}
  border: 2px solid #267dac;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`;

export const ModalHeaderContainer = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.mode?.allPersonnel?.modalHeaderContainerBGColor || '#267dac'};
    color: ${theme.mode?.allPersonnel?.modalHeaderContainerFontColor || '#ffffff'};
  `}
  border-radius: 6px;
  padding: 8px;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const FormGrid = styled.div<{ $columns?: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$columns || 3}, 1fr);
  margin-bottom: 1%;
  width: 100%;
`;

export const FormGroup = styled.div<{ $span?: number }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  grid-column: span ${(props) => props.$span || 1};

  .plasma-input-wrapper,
  input,
  .ant-select {
    width: 90% !important;
    margin-bottom: 1vh;
  }
`;

export const Label = styled.label`
  font-weight: bold;
  font-size: 14px;
  color: #334155;
`;

export const ErrorText = styled.span`
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;
`;

export const NormalPlasmaButton = styled(Button)`
  min-width: 5vw;
  border-radius: 6px !important;
  font-weight: 500 !important;
  min-height: 3vh !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 8px !important;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    opacity: 0.9;
    box-shadow: 0 2px 6px rgba(38, 125, 172, 0.25);
  }

  ${({ theme }) => css`
    background-color: ${theme.mode?.allPersonnel?.normalButtonBGColor || '#267dac'} !important;
    border: ${theme.mode?.allPersonnel?.normalButtonBorderColor || '1px solid #267dac'} !important;
  `}
`;
